// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 847) return "static/chunks/a18f0e56-272654971375ac56.js";
	if (chunkId === 414) return "static/chunks/414-b93e9b88e7a3679e.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"146":"datadog_browser_logs","340":"layout__client_site_chrome_ui","367":"layout__minimal","748":"datadog_browser_rum"}[chunkId] || chunkId) + "." + {"146":"8b791def6c4e3992","205":"2e90144ef4045da8","319":"0cbc2894a3f1b950","340":"13a1087bf8de8f81","367":"df98f0a1bf101340","639":"e7b660adfa99260e","748":"e62e476c544e261c"}[chunkId] + ".js";
};